import React from "react";
import Draggable from "react-draggable";
import StationPopover from "./StationPopover";
import SignalPulse from "./SignalPulse";
import { getStationColor } from "../utils/stationUtils";
import { STATION_SIZE, STATION_HALF_SIZE } from "../utils/constants";
import { editorCursor } from "../utils/editorCursor";

const DraggableStation = ({
  station,
  layoutType,
  activeLayoutType,
  position,
  bounds,
  selectedStationId,
  setSelectedStationId,
  onDragStop,
  axis,
  pxPerMeter = 0,
  // canvasMode (utils/editorCursor.js): the cursor follows 瀏覽 / 編輯模式.
  cursorMode = "edit",
}) => {
  const stationColor = getStationColor(station.category);
  const isSelected = selectedStationId === station.id;
  const isProtectionZone =
    station.category === "防護區" && station.radius_meters > 0 && pxPerMeter > 0;
  const radiusPx = isProtectionZone ? station.radius_meters * pxPerMeter : 0;

  return (
    <div
      key={station.id || `station-wrapper-${station.device_id || station.name}`}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: "none",
      }}
    >
      <Draggable
        axis={axis}
        position={position || { x: 50, y: 50 }}
        onStop={(e, data) => onDragStop(station.id, data)}
        bounds={bounds}
      >
        <div
          data-glyph="station"
          style={{
            cursor: editorCursor(cursorMode, "item", {
              locked: layoutType !== activeLayoutType,
            }),
            userSelect: "none",
            pointerEvents: "auto",
            display: "block",
            width: STATION_SIZE,
            height: STATION_SIZE,
            padding: 0,
            margin: 0,
            border: "none",
            boxSizing: "border-box",
            lineHeight: 0,
          }}
        >
          {station.category === "定位基站" && (
            <SignalPulse color={stationColor.primary} />
          )}
          {isProtectionZone && (
            <svg
              style={{
                position: "absolute",
                top: STATION_HALF_SIZE - radiusPx,
                left: STATION_HALF_SIZE - radiusPx,
                width: radiusPx * 2,
                height: radiusPx * 2,
                pointerEvents: "none",
                overflow: "visible",
              }}
              aria-hidden="true"
            >
              <circle
                cx={radiusPx}
                cy={radiusPx}
                r={radiusPx}
                fill="rgba(250, 140, 22, 0.2)"
                stroke={stationColor.border}
                strokeWidth={1}
              />
            </svg>
          )}
          <StationPopover
            station={station}
            stationColor={stationColor}
            isOpen={isSelected}
            layoutType={layoutType}
            activeLayoutType={activeLayoutType}
            trigger="click"
            onOpenChange={(open) => {
              setSelectedStationId(open ? station.id : null);
            }}
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                setSelectedStationId(isSelected ? null : station.id);
              }}
              style={{
                width: STATION_SIZE,
                height: STATION_SIZE,
                borderRadius: "50%",
                backgroundColor: stationColor.primary,
                border: `2px solid ${isSelected ? "#fff" : stationColor.primary}`,
                boxSizing: "border-box",
                boxShadow: isSelected
                  ? `0 0 0 2px ${stationColor.primary}, 0 2px 8px ${stationColor.primary}88`
                  : `0 2px 6px ${stationColor.primary}66`,
                transition: "all 0.2s ease",
                transform: isSelected ? "scale(1.2)" : "scale(1)",
              }}
            />
          </StationPopover>
        </div>
      </Draggable>
    </div>
  );
};

export default DraggableStation;
